import { useTranslation } from 'next-i18next';
import { AiGeneratingUI } from '../../AiGeneratingUI';
export const AiSingleOptionGeneratingOverlay = ({
  isVisible
}: {
  isVisible: boolean;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <AiGeneratingUI.SingleOption isVisible={isVisible} data-sentry-element="unknown" data-sentry-component="AiSingleOptionGeneratingOverlay" data-sentry-source-file="AiSingleOptionGeneratingOverlay.tsx">
      {t('ai.generate.creatingAnswer')}
    </AiGeneratingUI.SingleOption>;
};